import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings, DARK_THEME } from '@styles/index';

const StyledPlusCourseCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
  overflow: hidden;
  grid-column: span 6;
  @media only screen and (max-width: 47.95em) {
    grid-column: span 11;
  }
`;

const StyledSkeleton = styled(Skeleton)`
  @media only screen and (max-width: 47.95em) {
    &.thumbnail {
      width: 100% !important;
    }
  }
  ${({ theme }) =>
    theme.colors.type === DARK_THEME &&
    `background-color: ${theme.colors.whiteV3};`}
`;

const StyledPlusCourseCardDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.white};
  text-align: left;
  padding: ${Spacings.SPACING_4B};
`;

const CourseCard = ({ className }) => (
  <StyledPlusCourseCard className={className}>
    <StyledSkeleton
      variant="rect"
      width={272}
      height={153}
      className="thumbnail"
    />
    <StyledPlusCourseCardDetails>
      <StyledSkeleton height={22} width="20%" style={{ marginBottom: 8 }} />
      <StyledSkeleton height={20} width="100%" style={{ marginBottom: 8 }} />
      <StyledSkeleton height={20} width="30%" style={{ marginBottom: 8 }} />
      <StyledSkeleton height={12} width="70%" style={{ marginBottom: 16 }} />
      <StyledSkeleton height={18} width="40%" />
    </StyledPlusCourseCardDetails>
  </StyledPlusCourseCard>
);

CourseCard.propTypes = {
  className: PropTypes.string
};

CourseCard.defaultProps = {
  className: ''
};

export default CourseCard;
